// Lighten or darken a color.
// Copied from https://stackoverflow.com/a/37600815/1292652
export const adjustBrightness = (color: string, increment: number): string => {
    let usePound = false;

    if (color.startsWith('#')) {
        color = color.slice(1);
        usePound = true;
    }

    let R = parseInt(color.substring(0, 2), 16);
    let G = parseInt(color.substring(2, 4), 16);
    let B = parseInt(color.substring(4, 6), 16);

    // to make the colour less bright than the input
    // change the following three "+" symbols to "-"
    R = R + increment;
    G = G + increment;
    B = B + increment;

    if (R > 255) {
        R = 255;
    } else if (R < 0) {
        R = 0;
    }

    if (G > 255) {
        G = 255;
    } else if (G < 0) {
        G = 0;
    }

    if (B > 255) {
        B = 255;
    } else if (B < 0) {
        B = 0;
    }

    const RR = R.toString(16).length === 1 ? '0' + R.toString(16) : R.toString(16);
    const GG = G.toString(16).length === 1 ? '0' + G.toString(16) : G.toString(16);
    const BB = B.toString(16).length === 1 ? '0' + B.toString(16) : B.toString(16);

    return (usePound ? '#' : '') + RR + GG + BB;
};

export const makeTranslucent = (color: string, opacity: number): string => {
    const hexColor = color.replace('#', '');
    const alpha = Math.floor(opacity * 255)
        .toString(16)
        .padStart(2, '0');
    return `#${hexColor}${alpha}`;
};

export const makeDarker = (color: string, darknessFactor: number): string => {
    const hexColor = color.replace('#', '');
    const rgb = [
        parseInt(hexColor.slice(0, 2), 16),
        parseInt(hexColor.slice(2, 4), 16),
        parseInt(hexColor.slice(4, 6), 16),
    ];

    // Adjust RGB values to make the color darker
    const darkerRgb = rgb.map((channel) => {
        const adjustedChannel = channel - Math.floor((channel * darknessFactor) / 100);
        return Math.max(0, adjustedChannel); // Ensure channel value is not negative
    });

    // Convert darker RGB values back to hex
    const darkerHex = `#${darkerRgb
        .map((channel) => channel.toString(16).padStart(2, '0'))
        .join('')}`;

    return darkerHex;
};
